import { AfterContentInit, AfterViewInit, ContentChildren, Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { OutputItemsComponent } from './output-items/output-items.component';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[ubsSequentialOutputAnimation]',
  standalone: true
})

export class SequentialOutputAnimationDirective implements AfterViewInit, OnDestroy  {
  @ViewChildren(OutputItemsComponent) outputItems!: QueryList<OutputItemsComponent>;
  @Output() sequenceComplete = new EventEmitter<void>();
  
  //private outputItems: HTMLElement[] = [];
  private currentIndex = 0;
  private animationInProgress = false;
  private subs = new Subscription();
  private initialized = false;


  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    // Safety check for outputItems existence
    if (!this.outputItems) {
      this.handleAnimationError('outputItems QueryList is undefined');
      return;
    }

    // Initialize first animation
    this.initializeAnimation();
    // Handle dynamic data changes
    // Safely subscribe to changes with null checks
    const changesSubscription = this.outputItems.changes?.subscribe(() => {
      if (this.initialized) this.resetAnimation();
    });

    if (changesSubscription) {
      this.subs.add(changesSubscription);
    }
  }

  /* ngOnInit() {
    // Wait for content to be rendered
    setTimeout(() => {
      this.initializeAnimation();
    });
  } */

  /* initializeAnimation() {
    // Get all output item elements
    this.outputItems = Array.from(
      this.el.nativeElement.querySelectorAll('ubs-output-item')
    );
    
    if (this.outputItems.length > 0) {
      this.startNextAnimation();
    } else {
      // If no items, emit complete immediately
      this.sequenceComplete.emit();
    }
  } */
  initializeAnimation() {
    // Add safety checks
/*     if (!this.outputItems || this.outputItems.length === 0) {
      this.sequenceComplete.emit();
      return;
    }

    this.startNextAnimation();
 */
    this.initialized = true;
    setTimeout(() => this.resetAnimation(), 50);
  }

  resetAnimation() {
    this.currentIndex = 0;

    // Comprehensive safety check
    if (!this.outputItems || !this.outputItems.length) {
      this.handleAnimationError('No output items available for animation');
      return;
    }

    try {
      // Optional chaining for safe iteration
      this.outputItems?.forEach(comp => {
        if (comp) {
          comp.animationState = 'inactive';
        }
      });
      setTimeout(() => this.startNextAnimation(), 50);
    } catch (error) {
      this.handleAnimationError(`Animation reset failed: ${error}`);
    }
  }

  startNextAnimation() {
    /* if (this.currentIndex >= this.outputItems.length) {
      // All animations completed
      this.sequenceComplete.emit();
      return;
    }

    if (this.animationInProgress) {
      return;
    }

    this.animationInProgress = true;
    const currentItem = this.outputItems[this.currentIndex];
    
    // Listen for animation complete event from the component
    const subscription = this.renderer.listen(currentItem, 'animationComplete', () => {
      subscription(); // Remove listener
      this.animationInProgress = false;
      this.currentIndex++;
      // Give a small pause between animations
      setTimeout(() => {
        this.startNextAnimation();
      }, 200);
    });
    
    // Set animation state to active
    this.renderer.setProperty(currentItem, 'animationState', 'active'); */
    //New implementation
    /* if (this.currentIndex >= this.outputItems.length) {
      this.sequenceComplete.emit();
      return;
    }

    const currentComponent = this.outputItems.get(this.currentIndex);
    if (!currentComponent) return;

    // Directly interact with component instance
    currentComponent.animationState = 'active';
    
    // Listen to component's animationComplete event
    const sub = currentComponent.animationComplete.subscribe(() => {
      sub.unsubscribe();
      this.currentIndex++;
      setTimeout(() => this.startNextAnimation(), 200);
    }); */

    // Validate outputItems before proceeding
    if (!this.outputItems || this.currentIndex >= this.outputItems.length) {
      this.sequenceComplete.emit();
      return;
    }

    const currentComponent = this.outputItems.get(this.currentIndex);
    if (!currentComponent) {
      this.handleAnimationError(`Component not found at index ${this.currentIndex}`);
      return;
    }

    try {
      currentComponent.animationState = 'active';
      const sub = currentComponent.animationComplete?.subscribe(() => {
        this.currentIndex++;
        setTimeout(() => this.startNextAnimation(), 200);
      });
      
      if (sub) {
        this.subs.add(sub);
      }
    } catch (error) {
      this.handleAnimationError(`Animation start failed: ${error}`);
    }

  }

  private handleAnimationError(message: string) {
    console.error('Animation Error:', message);
    this.sequenceComplete.emit();
    this.subs.unsubscribe();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
